import { amountToDisplayValue, Color, Text } from '@billy/design-system'
import { Table } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { useBalanceLabels } from '@features/balanceLedger'

import type { LedgerEntryColumnDef } from '../../../../../../hooks/useLedgerEntriesTableColumns'
import * as Styled from './styles'

interface OpeningBalanceGroupHeaderProps {
  columns: LedgerEntryColumnDef[]
  totalBalance: number
}

export const OpeningBalanceGroupHeader = ({ columns, totalBalance }: OpeningBalanceGroupHeaderProps): ReactElement => {
  const { bt } = useBalanceLabels()
  const amountColor = totalBalance < 0 ? Color.Red700 : undefined
  const label = bt('detail_view.opening_balance.label')
  const balanceColumn = columns.at(-1)
  const labelColSpan = columns.length - 1

  return (
    <Table.Row data-opening-balance-header highlighted>
      <Table.Cell colSpan={labelColSpan}>
        <Styled.LabelWrapper>
          <Text weight="semiBold" nowrap>
            {label}
          </Text>
        </Styled.LabelWrapper>
      </Table.Cell>
      <Table.Cell align={balanceColumn?.align}>
        <Styled.AmountWrapper>
          <Text color={amountColor}>{amountToDisplayValue(totalBalance)}</Text>
        </Styled.AmountWrapper>
      </Table.Cell>
    </Table.Row>
  )
}
